import script from "./TaxExpendituresForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxExpendituresForm.vue?vue&type=script&setup=true&lang=js"

import "./TaxExpendituresForm.vue?vue&type=style&index=0&id=55811aec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55811aec"]])

export default __exports__